module.exports = __webpack_public_path__ + "img/hr-tree-07-g-trunk.4dcce991.png";